module.exports = __webpack_public_path__ + "static/media/BANKBARODA_F1.7b1ee3c3.txt";